import { RejectionFlags } from '../referentials/rejection-flag.model';
import { WaitingFlags } from '../referentials/waiting-flag.model';

export class InvoiceSearchCriteriaModel {

  Number: string;

  IsReverseFactoring: boolean | null | '';

  IsWorkingSituation: boolean | null | '';

  IsComplaint: boolean | null | '';

  RejectionFlag: RejectionFlags | null | '';

  WaitingFlag: WaitingFlags | null | '';

  RecipientEntity: string[] | null | '';

  SupplierName: string | null | '';

  ValidationType: ValidationType | null | '';

  InvoiceValidationStatusIds: InvoiceValidationStatus | null | '';

  VoucherValidationStatusIds: VoucherValidationStatus | null | '';

  PromotionValidationStatusIds: PromotionValidationStatus | null | '';

  PrimaryReference: string[] | null | '';

  FromReceptionDate: string | null;

  ToReceptionDate: string | null;

  FromInvoiceDate: string | null;

  ToInvoiceDate: string | null;

  FromProcessingDate: string | null;

  ToProcessingDate: string | null;

  ProcessingDateType: ProcessingDateTypes | null;

  FromAmount: number | null;

  ToAmount: number | null;

  SupplierSageErpCode: string | null;

  FromDueDate: string | null;

  ToDueDate: string | null;

  InvoiceInProgress: boolean = true;

  ExpenseFamilyCode : string | null;

  ExpenseTradeCode : string | null;
}

export enum ProcessingDateTypes {
  Operational = 1,
  Validation = 2,
  Comptability = 3
}

export enum ValidationType {
  Invoice = 1,
  Voucher = 2,
  All = Invoice | Voucher
}

export enum InvoiceType {
  Paper = 1,
  Email = 2,
  Direct = 3
}

export enum IsProcessed {
  No = 1,
  Yes = 2
}

export enum InvoiceValidationStatus {
  NotProcessed = 1,
  Processed = 2,
  All = NotProcessed | Processed
}

export enum VoucherValidationStatus {
  NotProcecced = 1,
  PendingForValidation = 2,
  Validated = 4,
  Accounted = 8,
  All = NotProcecced | PendingForValidation | Validated | Accounted,
}

export enum PromotionValidationStatus {
  NotProcessed = 1,
  PendingForWorkflowPromotionN1Completion = 2,
  PendingForWorkflowPromotionN2Completion = 4,
  PendingForWorkflowPromotionN3Completion = 8,
  AccountedPromotion = 16,
  All = NotProcessed | PendingForWorkflowPromotionN1Completion | PendingForWorkflowPromotionN2Completion | PendingForWorkflowPromotionN3Completion | AccountedPromotion,
}
